module.exports = __webpack_public_path__ + "img/current_hub_line_up.07880c71.png";